import * as z from 'zod';
import { ImageRefSchema } from '../bildebanken.js';
import { ParticipantsStatsRowSchema } from '../database.js';
import { StoredParticipantSchema, VideoRefSchema, } from '../firestore/participant.js';
export { StoredParticipantSchema as ParticipantSchema, VideoRefSchema };
export const CreateParticipantSchema = z.object({
    maskName: z.string().min(1),
    maskedOrderIdx: z.int().nonnegative(),
    imageRef: ImageRefSchema.optional(),
    costumeImageRef: ImageRefSchema.optional(),
    video: VideoRefSchema.optional(),
    guessText: z.array(z.string()).optional(),
    favoriteText: z.array(z.string()).optional(),
});
export const UpdateParticipantSchema = z.object({
    maskName: z.string().optional(),
    unmaskedName: z.string().min(1).nullable().optional(),
    imageRef: ImageRefSchema.optional(),
    costumeImageRef: ImageRefSchema.optional(),
    video: VideoRefSchema.optional(),
    guessText: z.array(z.string()).optional(),
    favoriteText: z.array(z.string()).optional(),
});
export const ReorderParticipantsSchema = z.object({
    order: z
        .array(z.object({ id: z.uuidv7(), maskedOrderIdx: z.int().nonnegative() }))
        .min(1),
});
export const ParticipantsStatsSchema = z.object({
    stats: z.array(ParticipantsStatsRowSchema),
});
//# sourceMappingURL=participant.js.map